import { pageRange, Pagination as SharedPagination } from '@routly/ui';

/**
 * The shared pager, with the console's English.
 *
 * The markup moved to `@routly/ui` once it turned out the product had its own,
 * which printed the page number twice.
 */

interface PaginationData {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

interface PaginationProps {
  pagination: PaginationData;
  currentPage: number;
  onPageChange: (page: number) => void;
  itemName?: string;
}

export function Pagination({
  pagination,
  currentPage,
  onPageChange,
  itemName = 'items',
}: PaginationProps) {
  const { first, last } = pageRange(pagination.page, pagination.limit, pagination.total);

  return (
    <SharedPagination
      page={currentPage}
      totalPages={pagination.totalPages}
      summary={`Showing ${first} to ${last} of ${pagination.total} ${itemName}`}
      previousLabel="Previous"
      nextLabel="Next"
      onPageChange={onPageChange}
      className="border-t px-4"
    />
  );
}
